module.exports = __webpack_public_path__ + "img/modern.7f74e6da.png";